import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const BOX_OFFICE_REPORT = gql`
  mutation BoxOfficeReportMutation($eventId: Int!) {
    getPOSRegistersReport(event_id: $eventId) {
      event {
        id
        logo
        name
        start_date
        end_date
        eventDates
        isMultiDay
        listDates
        day
        date
        fullDate
        month
        status
        track {
          id
          logo
          name
        }
        series {
          id
          name
        }
        account_name
      }
      data {
        cash
        card
        num_transactions
        num_tickets
        total_revenue
        ticket_breakdown_data {
          name
          price
          qty
          total
        }
        user {
          id
          formatted_name
        }
      }
      timeline {
        time
        count
        revenue
        sellers {
          id
          count
          revenue
        }
      }
    }
  }
`;

export function useGetBoxOfficeReport() {
  const [boxOfficeMutation] = useMutation(BOX_OFFICE_REPORT);
  const result = useCallback(
    (eventId) => {
      return boxOfficeMutation({
        variables: {
          eventId: Number(eventId),
        },
      });
    },
    [boxOfficeMutation]
  );
  return result;
}
